import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useProfileDetailsStyles = makeStyles((theme) =>
  createStyles({
    btnGroup: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'center',
      paddingBottom: 24,
      flexWrap: 'wrap'
    },

    blackButton: {
      height: '36px',
      padding: '0 14px 0x 14px',
      backgroundColor: '#424242',
      color: '#ffffff',

      '&:hover': {
        backgroundColor: '#727272'
      }
    },

    companyBtnsDiv: {
      display: 'flex'
    },

    portfolioBtn: {
      height: '36px',
      backgroundColor: 'white',
      border: '1px solid #E64147',
      borderRadius: '4px',
      padding: '0 14px 0 14px',
      marginLeft: '18px !important'
    },

    messagesBtn: {
      height: '36px',
      backgroundColor: '#E64147',
      borderRadius: '4px',
      padding: '0 14px 0x 14px',
      color: 'white'
    },

    reviewsButton: {
      height: '36px',
      padding: '0 14px 0x 14px',
      textTransform: 'none',
      fontSize: 18,
      fontWeight: 400,

      '& b': {
        fontWeight: 500
      }
    },

    cardTop: {
      display: 'flex',
      justifyContent: 'center',
      position: 'relative'
      // '&:after': {
      //   content: '""',
      //   position: 'absolute',
      //   zIndex: 2,
      //   display: 'block',
      //   width: 12,
      //   height: 12,
      //   borderRadius: '50%',
      //   backgroundColor: '#24C034',
      //   border: '4px solid #fff',
      //   bottom: 0,
      //   left: '57%',
      //   boxSizing: 'content-box'
      // }
    },

    premium: {
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      padding: '5px 9px',
      backgroundColor: '#F2C94C',
      borderTopLeftRadius: 4,
      borderBottomRightRadius: 4,
      [theme.breakpoints.down('xs')]: {
        padding: '1px 3px 1px 5px'
      }
    },
    premiumTitle: {
      color: '#fff',
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: 12,
      [theme.breakpoints.down('xs')]: {
        fontSize: 10
      }
    },

    defaultImg: {
      display: 'grid',
      placeItems: 'center',
      width: 176,
      height: 176,
      borderRadius: '50%',
      background: '#C4C4C4',
      color: '#fff',
      fontSize: 80,
      fontWeight: 500,
      fontFamily: 'Montserrat',
      [theme.breakpoints.down('md')]: {
        width: 125,
        height: 125,
        fontSize: 60
      },
      [theme.breakpoints.down('xs')]: {
        width: 86,
        height: 86,
        fontSize: 40
      }
    },

    avatarImage: {
      borderRadius: '50%',
      objectFit: 'cover',

      [theme.breakpoints.down('md')]: {
        width: 125,
        height: 125
      },
      [theme.breakpoints.down('xs')]: {
        width: 86,
        height: 86
      }
    },

    onlineIco: {
      width: 32,
      height: 32,
      backgroundColor: '#fff',
      borderRadius: '50%',
      position: 'absolute',
      zIndex: 3,
      bottom: 0,
      left: '57%',
      boxSizing: 'content-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },

    onlineTitle: {
      marginTop: 18,
      marginBottom: 16
    },

    card: {
      marginTop: theme.spacing(2)
    },

    title: {
      marginBottom: 8
    },

    textWrap: {
      display: 'flex',
      width: '100%',
      alignItems: 'center',

      '&:not(:last-child)': {
        marginBottom: 16
      }
    },

    text: {
      marginRight: 8
    },

    icon: {
      marginRight: theme.spacing(1),
      alignSelf: 'center'
    },

    avatarBlock: {
      position: 'relative'
    },

    avatar: {
      width: theme.spacing(20),
      height: theme.spacing(20),
      margin: theme.spacing(0, 'auto', 2)
    },

    crown: {
      position: 'absolute',
      left: '61%',
      top: 5,
      zIndex: 999
    },

    actions: {
      justifyContent: 'center'
    },

    groupChip: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      width: '100%',
      marginBottom: 16,

      '& > div': {
        overflow: 'hidden',
        marginBottom: 8,
        marginRight: 16
      }
    }
  })
)
